import React, { FC, useState } from 'react';
import { ReactComponent as SearchIcon } from 'src/assets/images/search-icon.svg';
import styled from 'styled-components';
import { IProductAvailability } from '../../graphql/types';
import { Grey, Grey2, MangoBlue, White2 } from '../../styles/colours';
import { DemiBold, Medium } from '../../styles/fonts';
import { ProductSearchForm } from './product-search-form';

const StyledTileContainer = styled.section`
  display: inline-flex;
  padding: 1rem 0rem 0rem 0rem;
`;

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${White2};
  border-right: 0.125rem solid ${Grey};
  border-radius: 0.25rem 0rem 0rem 0.25rem;
  padding: 1rem 1rem 2rem 1rem;
`;

const StyledUnitOfMeasureContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${White2};
  border-radius: 0rem 0.25rem 0.25rem 0rem;
  padding: 1rem 1.5rem 3rem 1.5rem;
`;

const StyledIdContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${White2};
  border-radius: 0rem 0.25rem 0.25rem 0rem;
  border-right: 0.125rem solid ${Grey};
  padding: 1rem 2rem 3rem 1.5rem;
`;

const StyledHeading = styled.div`
  font-size: 0.875rem;
  font-family: ${DemiBold};
  color: ${Grey2};
`;

const StyledData = styled.div`
  font-family: ${Medium};
  font-size: 1.125rem;
  padding: 0.25rem 0rem 0rem 0rem;
`;

const StyledButtonLink = styled.button`
  color: ${MangoBlue};
  font-family: ${Medium};
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
`;

const ButtonLinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.5rem;
  align-content: center;
  padding: 0rem 4.5rem 1.5rem 0rem;
`;

const SearchIconContainer = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  background: transparent;
  padding: 1px;
`;

export const ProductAvailabilityTile: FC<{
  shipToId: string;
  productAvailability: IProductAvailability;
}> = ({ shipToId, productAvailability }) => {
  const [edit, setEdit] = useState(false);
  return (
    <StyledTileContainer>
      <StyledDescriptionContainer>
        <StyledHeading>Product</StyledHeading>
        <StyledData>
          <div data-type="product-description">
            {productAvailability.product.description}
          </div>
        </StyledData>
        <div>
          {edit && (
            <>
              <ProductSearchForm
                shipToId={shipToId}
                plantId={productAvailability.plant.id}
                salesOrg={productAvailability.product.salesOrg}
              />
            </>
          )}
          {!edit && (
            <ButtonLinkContainer>
              <SearchIconContainer data-type="button" type="submit">
                <SearchIcon />
              </SearchIconContainer>
              <StyledButtonLink
                data-type="change-product-link"
                onClick={() => setEdit(!edit)}
              >
                Search for a different product
              </StyledButtonLink>
            </ButtonLinkContainer>
          )}
        </div>
      </StyledDescriptionContainer>
      <StyledIdContainer>
        <StyledHeading>Product ID</StyledHeading>
        <StyledData>
          <div data-type="product-id">{productAvailability.product.id}</div>
        </StyledData>
      </StyledIdContainer>
      <StyledUnitOfMeasureContainer>
        <StyledHeading>Unit of measure</StyledHeading>
        <StyledData>
          <div data-type="product-unit-of-measure">
            {productAvailability.product.unitOfMeasure}
          </div>
        </StyledData>
      </StyledUnitOfMeasureContainer>
    </StyledTileContainer>
  );
};
